let VideoEditor = {
    version: "26.0.2.17",
    releaseDD: "19",
    releaseMM: "02",
    releaseYYYY: "2026",
    size: "204.82",
    platforms: "Windows 11, 10, 8.1, 8, 7, Vista, XP (no Mac OS/ Linux support)"
};

let VideoReMaker = {
    version: "26.0.2.17",
    releaseDD: "19",
    releaseMM: "02",
    releaseYYYY: "2026",
    size: "92.58",
    platforms: "Windows 11, 10, 8.1, 8, 7, Vista, XP (no Mac OS/ Linux support)"
};

let VideoConverter = {
    version: "26.0.2.17",
    releaseDD: "19",
    releaseMM: "02",
    releaseYYYY: "2026",
    size: "119.16",
    platforms: "Windows 11, 10, 8.1, 8, 7, Vista, XP (no Mac OS/ Linux support)"
};

let MediaPlayer = {
    version: "26.0.2.17",
    releaseDD: "19",
    releaseMM: "02",
    releaseYYYY: "2026",
    size: "154.94",
    platforms: "Windows 11, 10, 8.1, 8, 7, Vista, XP (no Mac OS/ Linux support)"
};

let AudioEditor = {
    version: "26.0.2.17",
    releaseDD: "19",
    releaseMM: "02",
    releaseYYYY: "2026",
    size: "83.21",
    platforms: "Windows 11, 10, 8.1, 8, 7, Vista, XP (no Mac OS/ Linux support)"
};

let AudioConverter = {
    version: "26.0.2.17",
    releaseDD: "19",
    releaseMM: "02",
    releaseYYYY: "2026",
    size: "87.26",
    platforms: "Windows 11, 10, 8.1, 8, 7, Vista, XP (no Mac OS/ Linux support)"
};

let AVSImageConverter = {
    version: "26.0.2.17",
    releaseDD: "19",
    releaseMM: "02",
    releaseYYYY: "2026",
    size: "56.87",
    platforms: "Windows 11, 10, 8.1, 8, 7, Vista, XP (no Mac OS/ Linux support)"
};

export {VideoEditor, VideoReMaker, VideoConverter, MediaPlayer, AudioEditor, AudioConverter, AVSImageConverter};